"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _EmailAddress = _interopRequireDefault(require("PatternValidationJS/patterns/EmailAddress"));

var _GraderActionCreator = _interopRequireDefault(require("../actions/GraderActionCreator"));

var _HomepageLabelledInput = _interopRequireDefault(require("../components/HomepageLabelledInput"));

var _Url = _interopRequireDefault(require("PatternValidationJS/patterns/Url"));

var _InputUtil = _interopRequireDefault(require("../util/InputUtil"));

var _History = require("../util/History");

var _Paths = require("../constants/Paths");

var _Contact = require("../selectors/Contact");

var _Urls = require("../util/Urls");

var _useQuery2 = _interopRequireDefault(require("../hooks/useQuery"));

var PRIVACY_POLICY_URL = 'https://legal.hubspot.com/privacy-policy';

var getLangPolicyUrl = function getLangPolicyUrl() {
  var lang = window.I18N_MANUAL_LANG;

  if (lang !== 'en') {
    switch (lang) {
      case 'pt':
        return "https://legal.hubspot.com/br/privacy-policy";

      case 'ja':
        return "https://legal.hubspot.com/jp/privacy-policy";

      default:
        return "https://legal.hubspot.com/" + lang + "/privacy-policy";
    }
  }

  return PRIVACY_POLICY_URL;
};

var HomepageForm = function HomepageForm() {
  var _useQuery = (0, _useQuery2.default)(),
      website = _useQuery.website;

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(website),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      websiteUrl = _useState2[0],
      setWebsiteUrl = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      ignoreValidity = _useState4[0],
      setIgnoreValidity = _useState4[1];

  var contactEmail = (0, _reactRedux.useSelector)(_Contact.getEmail);

  var _useState5 = (0, _react.useState)(contactEmail),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      emailAddress = _useState6[0],
      setEmailAddress = _useState6[1];

  var isWebsiteValid = function isWebsiteValid() {
    return _Url.default.test(websiteUrl);
  };

  var isEmailValid = function isEmailValid() {
    return _EmailAddress.default.test(emailAddress);
  };

  var isInputValid = function isInputValid() {
    return isEmailValid() && isWebsiteValid();
  };

  var formSubmitted = function formSubmitted() {
    dispatch(_GraderActionCreator.default.storeContact(emailAddress));
  };

  var getButtonKey = function getButtonKey() {
    return 'home.form.button';
  };

  var buttonClicked = function buttonClicked(event) {
    // Don't ignore validity anymore
    setIgnoreValidity(false);

    if (isInputValid()) {
      var parsedWebsiteUrl = _InputUtil.default.parseWebsiteUrl(websiteUrl);

      var parsedUtmParams = (0, _Urls.parseUtmParams)(); // Go to the results page

      (0, _History.navigateTo)(_Paths.TESTS + "/" + parsedWebsiteUrl + "?" + parsedUtmParams); // Form has been submitted and we've moving to the next page

      formSubmitted();
    }

    event.preventDefault();
    return false;
  };

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    return false;
  };

  return _react.default.createElement("form", {
    className: "website-input",
    "data-test-id": "homepage-form",
    onSubmit: handleSubmit
  }, _react.default.createElement(_HomepageLabelledInput.default, {
    type: "url",
    "data-test-id": "url",
    errorText: _I18n.default.text('home.form.website.errorText'),
    labelText: _I18n.default.text('home.form.website.text'),
    onChange: function onChange(event) {
      var value = event.target.value;
      setWebsiteUrl(value);
    },
    onBlur: function onBlur(event) {
      var value = event.target.value;
      setWebsiteUrl(value.trim());
    },
    value: websiteUrl,
    isValid: function isValid() {
      return ignoreValidity || isWebsiteValid();
    }
  }), _react.default.createElement(_HomepageLabelledInput.default, {
    type: "email",
    "data-test-id": "email",
    errorText: _I18n.default.text('home.form.email.errorText'),
    noticeText: _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "home.form.email.noticeText",
      options: {
        target: getLangPolicyUrl()
      }
    }),
    labelText: _I18n.default.text('home.form.email.text'),
    onChange: function onChange(event) {
      var value = event.target.value;
      setEmailAddress(value);
    },
    onBlur: function onBlur(event) {
      var value = event.target.value;
      setEmailAddress(value.trim());
    },
    value: emailAddress,
    isValid: function isValid() {
      return ignoreValidity || isEmailValid();
    }
  }), _react.default.createElement("br", null), _react.default.createElement("button", {
    "data-test-id": "homepage-button-submit",
    className: "button primary",
    type: "submit",
    onClick: buttonClicked
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: getButtonKey()
  })));
};

var _default = HomepageForm;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/HomepageForm.js
// module id = 248
// module chunks = 0